import Vue from 'vue'

Vue.directive('autoFill', {
  update: function(el, { value }) {
    if (value) {
      el.className += ' qcc-auto-fill'
    }
  }
})



// WEBPACK FOOTER //
// ./src/directive/qcc.js